export default __webpack_public_path__ + "static/media/svg-3.fedc38aa.svg";